<template>
  <div>
    <Drawer title="请勾选要关联的报警" width="900" :mask-closable="false" @on-close="closeDrawer" :scrollable="true" v-model="showInDrawer">
      <Row>
        <Col span="8" class="u-flex">
        <span>报警指标： </span>
        <Input style="width:182px" v-model='dataForm.deviceName' @on-search="(e)=>searchInput(e,'deviceName')" search placeholder="请输入" />
        </Col>
        <Col span="8" class="u-flex">
        <span>报警时间：</span>
        <Input style="width:182px" v-model='dataForm.deviceName' @on-search="(e)=>searchInput(e,'deviceName')" search placeholder="请输入" />
        </Col>
        <!-- 列表 -->
        <div class="common-list">
          <Table class="equipmentTable" :loading="warningListLoading" :columns="colManager" :data="warningLists">
          </Table>
        </div>
        <!-- 分页器 -->
        <div class="common-page fr" v-if='pageInfo.total'>
          <Page show-total :total="pageInfo.total" :current="pageInfo.current" :page-size='pageInfo.size' @on-change='getWarningLists'></Page>
        </div>
      </Row>
    </Drawer>
  </div>
</template>

<script>
import {alarmPage} from '@/api/business/rhdetail'
  export default {
    data() {
      return {
        showInDrawer: true,
        dataForm: {
          deviceName: ""
        },
       
         warningListLoading: false,
         warningLists:[],
        colManager: [{
            title: "报警描述",
            key: "describe",
            width: 500,
            render: (h, params) => {
              const desc = params.row.describe;
              let desc290 = "";
              if (desc && desc.length > 290)
                desc290 = desc.substring(0, 290) + "...";
              else desc290 = desc || "-";
              return h("div", desc290);
            },
          },
          {
            title: "报警开始时间",
            key: "alarmStartTime",
            render: (h, params) => {
              const item = params.row
              return h("div", item.alarmStartTime || "-");
            }
          },
          {
            title: "报警结束时间",
            key: "alarmEndTime",
            render: (h, params) => {

              const {
                index
              } = params
              const item = params.row;
              let msg = "" //da
              let alarmStatus = this.curDetails.alarmStatus
              if (index == 0) { //当第一条的时候 如果状态不是正常的状态下  显示- 否则则正常显示
                if (alarmStatus == 0 || alarmStatus == 2) {
                  msg = item.alarmEndTime
                } else {
                  msg = item.alarmEndTime
                }
              } else {
                msg = item.alarmEndTime || "-"
              }

              return h("div", msg || "-");
            },
          },
          {
            title: "报警持续时间",
            key: "alarmDuration",
            width: 140,
            align: 'left',
            render: (h, params) => {
              const item = params.row;


              return h(
                "div", {
                  style: {
                    whiteSpace: 'nowrap'
                  }
                },
                this.timeChange(item.alarmDuration)
              );

            },
          },
          {
            title: "操作",
            key: "address",
            align: 'left',
            className: "action",
            render: (h, params) => {
              const item = params.row;
              return h("div", [
                h(
                  "span", {
                    props: {
                      size: "small",
                    },
                    style: {
                      color: "#0c479d", //"#e9aa69",
                      cursor: "pointer",
                      // marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        this.nvtodetl(item)
                      },
                    },
                  },
                  "详情"
                ),
              ]);
            },
          },
        ],
      }
    },
    methods: {
      closeDrawer() {

      },
        getWarningLists(page) {
        if (page) this.pageInfo.current = page; //分页处理
        alarmPage({
          ...this.pageInfo,
          oilSiteIds: [this.curId],
        }).then((res) => {
          if (res.code === "00000") {
            const datas = res.data;
            this.warningLists = datas.records;

            // this.warid = datas.records.length > 0 ? datas.records[0].id : ""

            if (this.warningLists.length)
              this.alarmTime =
              this.warningLists[0].alarmStartTime || "";

            this.pageInfo.total = datas.total;
          }
          setTimeout(() => {
            this.warningListLoading = false;
          }, 500);
        });
      },
    }
  }
</script>